import React from 'react';
import './Modal.css';

const ModalConfirmDelete = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-card blue-theme">
        <button className="btn-close-modal" onClick={onClose}>&times;</button>
        
        <p className="modal-message">Confirmar a exclusão?</p>
        
        <div className="modal-actions">
          <button className="btn-modal-action" onClick={onClose}>Cancelar</button>
          <button className="btn-modal-action" onClick={onConfirm}>Confirmar</button>
        </div>
      </div>
    </div>
  );
};

export default ModalConfirmDelete;